import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core';
import { SelectComponent, TextAreaComponent } from '../../components/FormElement';
import CustomTypo from '../../components/CustomTypo';
import CustomizedCircularProgress from '../../components/CircularProgress';
import validators from '../../utils/validators';
import ButtonCustom from '../../components/ButtonCustom';
import { Field, Form } from 'react-final-form';
import { AddIcon, CloseIcon } from '../../components/icons';
import DrawerCustom from '../../components/DrawerCustom';
import Modal from '../../components/Modal';
import FileUploader from '../../components/UploadFiles';
import ModalConfirm from '../../components/ModalConfirm';
import { domainName, portal_config } from '../../../portal.config';

const styles = theme => ({
    button: {
        marginTop: theme.spacing(8)
    },
    form: {
        marginTop: theme.spacing(16)
    },
    upload_image: {
        backgroundColor: theme.palette.background.secondary,
        padding: theme.spacing(3),
        borderRadius: theme.spacing(5),
        margin: theme.spacing(4, 0, 0, 0),
        cursor: 'pointer',
        border: '1px solid ' + theme.palette.background.card,
    },
    images: {
        padding: theme.spacing(3, 0),
    },
    box_image: {
        // height: theme.spacing(20),
        width: '100%',
        position: 'relative',
    },
    image: {
        border: '1px solid ' + theme.palette.border.primary,
        borderRadius: theme.spacing(2),
        width: '100%',
        height: '100px'
    },
    delete: {
        position: 'absolute',
        top: 0,
        right: 0,
    },
    icon_delete: {
        padding: theme.spacing(1),
        borderRadius: '50%',
        border: '1px solid ' + theme.palette.border.primary,
        backgroundColor: theme.palette.background.onCard,
        cursor: 'pointer',
    },
});

function NewServiceRequestView(props) {
    const { classes, t, request_info, showLoading, onSelectQueue, onCreate, queues, showUploadFile, onShowUploadFile } = props;
    console.log('setQueues item= ', queues)
    //console.log("profile======== ", profileName)
    return (
        <div>
            <DrawerCustom
                open={props.open}
                onClose={props.onClose}
                title={t('new_service_request')}
                children={
                    <Grid item >
                        <Grid item container justify='center' alignItems='center'>
                            {showLoading && <CustomizedCircularProgress />}
                        </Grid>
                        <Form
                            onSubmit={onCreate}
                            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                <Grid xs={12} container item justify='center' className={classes.form}>
                                    {/* <Grid xs={12} item container>
                                        <Field
                                            name="title"
                                            component={TextFieldComponent}
                                            label={t('title')}
                                            defaultValue={service_request.title}
                                            isEdit={true}
                                            color='default'
                                            validate={validators.composeValidators(validators.required)}
                                        />
                                    </Grid> */}

                                    <Grid xs={12} item container>
                                        <Field
                                            name="classification_id"
                                            component={SelectComponent}
                                            label={t('classification')}
                                            selectData={props.queues}
                                            //defaultValueSelect={address_types[0].value}
                                            valueSelect={request_info.queue_id ? request_info.queue_id : null}
                                            onSelectedChange={(event) => onSelectQueue(event.target)}
                                            color='default'
                                            placeholder={t('Select')}
                                            isEdit={true}
                                        />
                                    </Grid>

                                    <Grid xs={12} item container>
                                        <Field
                                            name="description"
                                            component={TextAreaComponent}
                                            label={t('description')}
                                            isEdit={true}
                                            color='default'
                                            labelColor='default'
                                            defaultValue={request_info.description}
                                            //onCustomChange={handleChange}
                                            multiline
                                            validate={validators.composeValidators(validators.required)}
                                        //onChange={(text) => this.props.onHandleChange('first_name', text)}
                                        />
                                    </Grid>

                                    {portal_config[domainName].showUploadFileSR && <Grid item xs={12} container alignItems='center' className={classes.upload_image} onClick={() => props.onShowUploadFile(true)} id="btn_sr_upload_file">
                                        <Grid item xs={10} container>
                                            <CustomTypo>{t('attach_files')}</CustomTypo>
                                        </Grid>
                                        <Grid item xs={2} container justifyContent='flex-end'>
                                            <AddIcon />
                                        </Grid>
                                    </Grid>}
                                    <Grid item xs={12} className={classes.images}>
                                        <Grid item xs={12} container spacing={3} alignItems='center'>
                                            {props.files && props.files.length > 0 && props.files.map((item, index) => {
                                                return (
                                                    <Grid item xs={12} sm={3} key={index}>
                                                        <Grid item className={classes.box_image}>
                                                            <img src={item.preview} alt="Image" className={classes.image}></img>
                                                            <Grid item className={classes.delete}>
                                                                <Grid item className={classes.icon_delete} onClick={() => props.onDeleteFile(item)} data-sr-upload-file-id={item.id}>
                                                                    <CloseIcon style={{ color: 'grey', width: 20, height: 20 }} />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                );
                                            })}
                                        </Grid>
                                    </Grid>
                                    <Grid xs={12} item container justify='center' className={classes.button}>
                                        <ButtonCustom color='primary' fullWidth onClick={handleSubmit} id="btn_service_request_submit">{t('btn_submit')}</ButtonCustom>
                                    </Grid>
                                </Grid>
                            )} />
                    </Grid>
                }
            />
            {/* {showUploadFile && <Modal
                open={showUploadFile}
                // maxWidth={900}
                title={t('upload_files')}
                content={<UploadFileModal t={t} classes={classes}
                    onCompleteFileUpload={props.onCompleteFileUpload}
                />}
                onClose={() => onShowUploadFile(false)}
            />} */}
            {showUploadFile && <ModalConfirm
                open={showUploadFile}
                // maxWidth={900}
                isCustomMessage={true}
                title={t('upload_files')}
                confirm={t('btn_ok')}
                message={<UploadFileModal t={t} classes={classes}
                    onCompleteFileUpload={props.onCompleteFileUpload}
                />}
                onClose={() => onShowUploadFile(false)}
                onAction={() => props.onSaveStateFiles()}
            />}
        </div>
    );
}

function UploadFileModal(props) {
    const { t, classes, onCompleteFileUpload } = props;

    return (
        <Grid item xs={12}>
            <FileUploader
                t={t}
                multiple={false}
                onFileUpload={(files) => onCompleteFileUpload(files)}
            />
        </Grid>
    );
}
export default withStyles(styles)(withTranslation()(NewServiceRequestView));